import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/wie-free-trial-success.webp';

const thumbHashString = 'd/eBC4I6lc2vQnMHinOQOAdHgIeEaXg=';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 1.986758214811182;
const originalWidth = 4051;

const WieFreeTrialSuccess = ({
  aspectRatio = calculatedAspectRatio,
  width = originalWidth,
  ...rest
}: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default WieFreeTrialSuccess;
